/**
 * Intercepte la touche back Android sur l'accueil PWA — demande un
 * double-tap avant de fermer l'app (comportement Android natif classique).
 *
 * Fonctionne dans une TWA (Trusted Web Activity) et dans le navigateur
 * en mode standalone : les deux consomment `popstate` quand l'utilisateur
 * touche le bouton back système.
 *
 * Retour utile aussi pour les pages secondaires (Fiche/Settings) : elles
 * doivent naviguer avec `replace: true` pour ne pas polluer l'historique,
 * ce qui rend le back "retour accueil" naturel.
 */
import { useEffect, useState } from 'react';

export function useExitConfirm(message: string = 'Appuyez à nouveau pour quitter') {
  const [prompt, setPrompt] = useState<string | null>(null);

  useEffect(() => {
    let lastPress = 0;
    // Push initial : ajoute un état à l'historique pour que le premier back
    // soit intercepté au lieu de fermer directement l'onglet/TWA.
    try { window.history.pushState({ verif_home: true }, '', window.location.href); } catch { /* */ }

    const onPop = (e: PopStateEvent) => {
      const now = Date.now();
      if (now - lastPress < 2000) {
        // 2e tap dans la fenêtre → laisser passer (TWA/tab se ferme)
        return;
      }
      // 1er tap : bloquer + toast + re-push
      lastPress = now;
      try { window.history.pushState({ verif_home: true }, '', window.location.href); } catch { /* */ }
      setPrompt(message);
      setTimeout(() => setPrompt(null), 2000);
    };
    window.addEventListener('popstate', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
    };
  }, [message]);

  return prompt;
}
